import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingScreenProps {
  message?: string
}

/**
 * Lightweight in-flow loading placeholder.
 * Avoids fixed 100vh overlays that cause large CLS when content mounts.
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = 'Loading...',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { xs: 280, sm: 360 },
        width: '100%',
        py: 6,
      }}
      role="status"
      aria-live="polite"
    >
      <CircularProgress size={40} color="primary" />
      <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
        {message}
      </Typography>
    </Box>
  )
}

export default LoadingScreen
